import { render } from "./ConsultingDetailServer.vue?vue&type=template&id=e20b4894"
import script from "./ConsultingDetailServer.vue?vue&type=script&lang=js"
export * from "./ConsultingDetailServer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__